import LinkJump from '@gp/components/LinkJump';
import { getCombinedIdsByGameType } from '@gp/services/projectDetail';
import { queryJumpable } from '@gp/utils/common';
import React from 'react';
import ProjectsItems from '../ProjectsItems';
import './index.scss';
export default function SimilarItem(props: any) {
  const { gameInfo, allCountryFlag = {} } = props;

  const getTypeByNum = (num: number) => {
    switch (num) {
      case 1:
        return 'mobile';
      case 2:
        return 'pc';
      case 3:
        return 'console';
      default:
        return '';
    }
  };

  const toDetails = (isJump = true, gameId?: string, gameType?: any) => {
    if (!(gameInfo?.unified_id && gameInfo?.game_type)) return '';
    const gameIdCur = gameId || gameInfo?.unified_id;
    const gameTypeCur = gameType || gameInfo?.game_type;
    let link = '';
    switch (
      gameTypeCur // 1: mobile, 2: pc, 3: console
    ) {
      case 1:
        link = `${window?.location?.origin}/v2/intelligence/topCharts/mobileGames/gamesDetails/${gameIdCur}/stats/activeusers`;
        break;
      case 2:
        link = `${window?.location?.origin}/v2/intelligence/topCharts/pcGames/gamesDetails/${gameIdCur}/stats/pcu`;
        break;
      case 3:
        link = `${window?.location?.origin}/v2/intelligence/topCharts/consoleGames/gamesDetails/${gameIdCur}/stats/digitalRevenue`;
        break;
      case 4:
        link = `${window?.location?.origin}/v2/intelligence/topCharts/pcConsoleGames/gamesDetails/${gameIdCur}/stats`;
        break;
      default:
        break;
    }
    if (isJump && link) {
      const elink = document.createElement('a');
      elink.style.display = 'none';
      elink.href = link;
      elink.target = '_blank';
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    }

    return link;
  };

  // 查询combineid
  const toDetailsTrueFun = async (isJump = true) => {
    if (!(gameInfo?.unified_id && gameInfo?.game_type)) return '';
    const entityType = getTypeByNum(gameInfo?.game_type);
    if (entityType && (gameInfo?.game_type === 2 || gameInfo?.game_type === 3)) {
      try {
        const result: any = await getCombinedIdsByGameType({
          entity_type: entityType,
          id: gameInfo?.unified_id,
        });
        const combineGameListTemp = result?.data?.data?.filter(
          (item: any) => item?.id && item?.id !== 'None' && item?.id !== '',
        );
        if (
          combineGameListTemp?.filter((item: any) => item.entity_type === 'combine')?.length > 0
        ) {
          const combineGame = combineGameListTemp?.filter(
            (item: any) => item.entity_type === 'combine',
          );
          toDetails(isJump, combineGame?.id, 4);
        } else {
          toDetails(isJump);
        }
      } catch (err) {
      } finally {
      }
    } else {
      toDetails(isJump);
    }
  };

  return (
    <LinkJump url={toDetails(false)}>
      <div
        className="dbg-project-detail__body-similar-games font14"
        onClick={(e) => {
          if (!queryJumpable(e)) return;
          toDetailsTrueFun(true);
        }}
      >
        <ProjectsItems
          toDetails={toDetails}
          data={{
            project: gameInfo?.name || '-',
            cover: gameInfo?.cover,
            country_en_name_abbr: gameInfo?.country_en_name_abbr,
            country_en_name: gameInfo?.country_en_name,
            game_type:
              { 1: 'other-icon', 2: 'monitor', 3: 'game' }[gameInfo?.game_type] || 'mobile',
          }}
          bubble={
            <>
              <p>{gameInfo?.name || '-'}</p>
              <p>Company：{gameInfo?.publisher_name || '-'}</p>
              <p>Region：{gameInfo?.region || '-'}</p>
            </>
          }
          allCountryFlag={allCountryFlag}
          toDetailsTrueFun={toDetailsTrueFun}
          isNeedPromise={true}
        ></ProjectsItems>
      </div>
    </LinkJump>
  );
}
